<template>
    <router-view />
</template>

<script>
export default {
    name: 'OwRouterView',
};
</script>
